import apolloFetch from './apollo';
import orderMutations from './mutations/order';
import userMutations from './mutations/user';
import weeklyMenuMutations from './mutations/weeklyMenu';
import allergyQueries from './queries/allergy';
import cateringQueries from './queries/catering';
import dietQueries from './queries/diet';
import eventQueries from './queries/event';
import officeQueries from './queries/office';
import orderQueries from './queries/order';
import userQueries from './queries/user';
import versionQueries from './queries/version';
import weeklyMenuQueries from './queries/weeklyMenu';

export default {
  version: {
    queries: versionQueries,
  },
  user: {
    queries: userQueries,
    mutations: userMutations,
  },
  weeklyMenu: {
    queries: weeklyMenuQueries,
    mutations: weeklyMenuMutations,
  },
  office: {
    queries: officeQueries,
  },
  order: {
    queries: orderQueries,
    mutations: orderMutations,
  },
  diet: {
    queries: dietQueries,
  },
  event: {
    queries: eventQueries,
  },
  allergy: {
    queries: allergyQueries,
  },
  catering: {
    queries: cateringQueries,
  },
  apolloFetch,
};



// WEBPACK FOOTER //
// ./src/graphql/index.js